<template>
  <div :style="{'width':width + 'px'}" style="height: 5px;background-color: #1D2638; position: relative;overflow: hidden;"><!-- value + '%' -->
    <div :class="[{'type1':type==1},{'type2':type==2}]" :style="{width:`calc(${value}% - 6px)`}" class="bar"></div>
    <div class="showbar" v-show="value" :style="{left:getWeith}"></div>
  </div>
</template>

<script>
  export default{
    data(){
      return {

      }
    },
    computed:{
      getWeith(){
        return `calc(${this.value}% - 16px)`
      }
    },
    props:{
      // 进度条百分比
      value:{
        default: 0,
        type: Number
      },
      // 1 正常 2 超出
      type:{
        default: 1,
        type: Number
      },
      // 父容器宽
      width:{
        default: 268,
        type: Number
      }
    }
  }
</script>

<style scoped>
  .bar{
    height: 5px;
    max-width: 100% !important;
  }
  .type1{
    background: -webkit-gradient(linear, left, right, color-stop(0%,#258EBB), color-stop(100%,#258EBB));
    background: -o-linear-gradient(left, #052445 0%,#258EBB 100%);
    background: -ms-linear-gradient(left, #052445 0%,#258EBB 100%);
    background: linear-gradient(left, #052445 0%,#258EBB 100%);
    background: -webkit-linear-gradient(left,#052445,#258EBB);
    background: -moz-linear-gradient(left,#052445,#258EBB);
  }
  .type2{
    background: -webkit-gradient(linear, left, right, color-stop(0%,#258EBB), color-stop(100%,#DD6E24));
    background: -o-linear-gradient(left, #052445 0%,#DD6E24 100%);
    background: -ms-linear-gradient(left, #052445 0%,#DD6E24 100%);
    background: linear-gradient(left, #052445 0%,#DD6E24 100%);
    background: -webkit-linear-gradient(left,#052445,#DD6E24);
    background: -moz-linear-gradient(left,#052445,#DD6E24);
  }
  .showbar{
    width: 17px;
    height: 5px;
    background-image: url(../../assets/image/energy/showbar.png);
    background-repeat: no-repeat;
    background-size: 21px 18px;
    background-position: 0 -6px;
    position: absolute;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Energy/ProgressBar.vue